<div class="dialog-header">
  <span class="dialog-title">Add Team</span>
  <span class="material-symbols-outlined dialog-close close-button" (click)="dialogRef.close()" type="button">close</span>
</div>

<div class="dialog-content">
  <div class="field">
    <label class="field__label">Team Name</label>
    <input class="field__input" type="text" [(ngModel)]="friendlyName" #nameCtrl="ngModel" required
      placeholder="Team Name">
  </div>
  <small class="dialog-hint">Teams are created using default markup values. To adjust these values, please edit the team
    after creation.</small>
</div>

<div class="dialog-actions">
  <button class="cancel-button" mat-dialog-close type="button">Cancel</button>
  <button class="save-button" type="button" (click)="save()">Submit</button>
</div>